import { PropsWithChildren, ComponentProps } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';

type Props = ComponentProps<typeof Heading>;

export const FormHeading = ({ children, ...props }: PropsWithChildren<Props>) => {
  return (
    <Heading level={3} css={headingStyles} {...props}>
      {children}
    </Heading>
  );
};

const headingStyles = css({
  marginBottom: theme.spacing(2),
});
